// extracted by mini-css-extract-plugin
export default {"root":"BriefEditor__root--8wRMbB","title":"BriefEditor__title--miP-5J"};